import React from 'react'
import { Form, Input, InputNumber, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateIrrigationType } from '@graphql/mutations'

function ManageIrrigationTypeForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createIrrigationType, { loading }] = useCreateIrrigationType()

  const onFinish = data => {
    createIrrigationType({
      variables: {
        data: {
          ...data,
          efficiency: parseFloat(data.efficiency),
        },
      },
      refetchQueries: ['GetIrrigationTypesQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do tipo de rega" size="large" autoFocus />
      </Form.Item>

      <Form.Item
        name="efficiency"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <InputNumber placeholder="Eficiência" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar tipo de rega
      </Button>
    </Form>
  )
}

ManageIrrigationTypeForm.propTypes = {
  afterSubmit: func,
}

ManageIrrigationTypeForm.defaultProps = {
  afterSubmit: null,
}

export default ManageIrrigationTypeForm
